module.exports = __webpack_public_path__ + "static/img/1_0025.8ad47ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0025.jpg
// module id = omsb
// module chunks = 0